import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from '@/components/Login.vue'; // Existing
import UserDashboard from '@/components/Dashboard.vue'; // Existing
import UserHome from '@/components/Home.vue'; // Existing
import UserProfile from '@/components/Profile.vue'; // Existing

// Import the new components (adjust path if needed, e.g., '@/views/')
import UserRegister from '@/components/Register.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import ResetPassword from '@/components/ResetPassword.vue';
import VerificationResult from '@/components/VerificationResult.vue'; // New component

const routes = [
  {
    path: '/',
    redirect: '/dashboard', // Keep existing redirect
  },
  {
    path: '/login',
    name: 'Login',
    component: UserLogin,
    meta: { requiresGuest: true } // Add meta field for guest-only routes
  },
  // --- New Routes ---
  {
    path: '/register',
    name: 'Register',
    component: UserRegister,
    meta: { requiresGuest: true } // Add meta field for guest-only routes
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresGuest: true } // Also guest-only usually
  },
  {
    path: '/reset-password', // Token will be expected as query param: ?token=...
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresGuest: true } // Also guest-only usually
  },
  {
    path: '/verification-result',
    name: 'VerificationResult',
    component: VerificationResult // Adjust path if needed
  },
  // --- End New Routes ---
  {
    path: '/dashboard',
    component: UserDashboard,
    meta: { requiresAuth: true }, // Add meta field for authenticated routes
    children: [
      {
        path: '', // Default child route for /dashboard
        name: 'Home',
        component: UserHome,
      },
      {
        path: 'profile', // Path becomes /dashboard/profile
        name: 'Profile',
        component: UserProfile,
      },
      // Add other dashboard child routes here
    ],
  },
   // Optional: Add a catch-all 404 route
   // { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/components/NotFound.vue') }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // Use BASE_URL if defined (good practice)
  routes,
});

// Updated Route Guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('jwt'); // Or however you store your token
  const isLoggedIn = !!token;

  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      // Redirect to login page if not logged in and trying to access protected route
      next({ name: 'Login' });
    } else {
      // Allow navigation if logged in
      next();
    }
  }
  // Check if the route requires guest (not logged in)
  else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (isLoggedIn) {
      // Redirect to dashboard if logged in and trying to access guest-only route
      next({ name: 'Home' }); // Or '/dashboard' or '/' depending on your preference
    } else {
      // Allow navigation if not logged in
      next();
    }
  }
  // For routes that don't require auth or guest status
  else {
    next();
  }
});

export default router;